<template>
    <div>
        <!-- Modal Open Pacs Viewer -->
        <div class="modal fade" id="openPacsViewer" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" v-if="dados">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Visualizador / PACS</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info d-flex justify-content-between" v-if="dados.accession_number">
                            <div>
                                <strong>Accession Number:</strong> {{ dados.accession_number }}
                            </div>
                            <div>
                                <div class="small text-muted" v-if="tipo">{{ tipo }}</div>
                            </div>
                        </div>

                        <div class="list-group">
                            <a href="#" @click.prevent="selecionar(info, chave)" class="list-group-item list-group-item-action" v-for="(info, chave) in dados.viewers" :key="chave">
                                {{ info.name }}

                                <div v-if="$store.state.user.id_usuario == 1" class="small text-muted text-truncate">
                                    {{ info.url }}
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() {
        return {
            dados: null, 
            tipo: "", 
        };
    },

    methods: { 
        selecionar (info, chave) { 
            this.tipo = chave;
            this.$util.pacs_open_window(info.url);

            $('#openPacsViewer').modal('hide');
        },

        abrir(dados) {

            console.log("Abrir PACS Viewer", _.keys(dados.viewers));

            if ( dados && dados.viewers && _.keys(dados.viewers).length > 1 ) {

                if ( this.tipo && dados.viewers[this.tipo] && dados.viewers[this.tipo].url ) {
                    if ( this.$util.pacsTabWindow && !this.$util.pacsTabWindow.closed ) {
                        this.$util.pacs_open_window(dados.viewers[this.tipo].url);
                        return; 
                    }
                }

                this.dados = dados;

                this.$nextTick(() => {
                    $('#openPacsViewer').modal('show');
                });

                return; 

            }

            if ( dados.url ) { 
                this.$util.pacs_open_window(dados.url);
            } else { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "PACS Viewer não identificado.",
                    life: 3000
                });
            }

        }

    }

}
</script>
